import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import style from 'styled-components';

import { GIButton } from 'app-components';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';

const StyledHeader = style.div`
    display: flex;
    justify-content: space-between;
`;
const StyledHeaderText = style.h4`
    margin: 0;
`;

const AddOrChangeEnrollmentTxnHeading = () => {
    const intl = useIntl();
    const { isEdit, setViewAddOrChangeTxn } = useContext(EnrollmentContext);

    const onBackClick = () => {
        setViewAddOrChangeTxn(false);
    };

    return (
        <StyledHeader className="header">
            <StyledHeaderText>
                {intl.formatMessage({ id: 'member.enrollment_list' })} -{' '}
                {intl.formatMessage({
                    id: isEdit
                        ? 'member.enrollment_list.premiumhistory.change'
                        : 'member.enrollment_list.premiumhistory.add',
                })}
            </StyledHeaderText>
            <GIButton
                id="btn-back"
                variant="secondary"
                onClickHandler={onBackClick}
                label={intl.formatMessage({ id: 'button.back' })}
            />
        </StyledHeader>
    );
};

export default AddOrChangeEnrollmentTxnHeading;
